module.exports = __webpack_public_path__ + "static/media/Nasscom01.1c3e9adb.jpg";